/** @jsx jsx */
/**
 * Customizations:
 * - Show Chianti Classico logo instead of default logo.
 */

import { Link } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import logo from '../../../../assets/logo-chianticlassico.svg';

export default function Logo({ to, isScrolledDown, alt, ...rest }) {
  if (!to) return <img src={logo} alt={alt} sx={{ height: 80 }} />;

  return (
    // On logos, it's allowed to use external links on 'to' (to possibly link to a main website).
    // The Link component takes care of that. We need to suppress the warning though.
    <Link to={to} _suppressExternalLinkWarning {...rest}>
      <Logo src={logo} />
    </Link>
  );
}
